/**
 * Remembers where an unauthenticated visitor was trying to go, so that after they log in
 * we can send them back there instead of dumping them on the dashboard. This is what makes
 * a deep link — e.g. a "Customer Approvals" link emailed to a partner — actually work.
 *
 * Stored in sessionStorage rather than router state because the OTP login flow can span a
 * reload, and it should not survive into a new tab or a later session.
 *
 * Lives in its own module (rather than App.js) so Login can use it without a circular import.
 */

const KEY = "postLoginRedirect";

/** Called by the route guard when it bounces someone to /login. */
export function rememberPostLoginRedirect(path) {
  try {
    if (path && path !== "/login") sessionStorage.setItem(KEY, path);
  } catch (_) {}
}

/**
 * Called once on successful login. Returns the remembered in-app path, or null.
 * Only same-origin absolute paths are honoured — a value starting with "//" would be a
 * protocol-relative URL to another host, i.e. an open redirect.
 */
export function consumePostLoginRedirect() {
  try {
    const target = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (target && target.startsWith("/") && !target.startsWith("//") && target !== "/login") {
      return target;
    }
  } catch (_) {}
  return null;
}
